<template>
  <div>
    <Head
      :title="seoTitle"
      :description="seoDescription"
    />

    <Home>
      <div class="container mx-auto py-4">
        <div class="w-full p-4 rounded-lg bg-white">
          <div class="prose max-w-full">
            <ul>
              <li
                v-for="(link, index) in links"
                :key="index"
              >
                <a
                  :href="link"
                  v-text="link"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Home>
  </div>
</template>

<script>
import Home from '../../Layouts/Home.vue';
import Head from '../../Partials/Head.vue';

export default {
  components: {
    Home,
    Head,
  },

  props: {
    seoTitle: {
      type: String,
      required: true,
    },

    seoDescription: {
      type: String,
      required: true,
    },

    links: {
      type: Array,
      required: true,
    },
  },
};
</script>


